import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import T from 'aegisv2/Text';
import ArrowRight from 'crehana-icons/ArrowRight';
import Info from 'crehana-icons/Info';
import GroupTitle from 'Catalog/ui/GroupTitle';
import Flex from 'Shared/ui/Flex';
import Button from 'Catalog/ui/Button';

const Root = styled(Flex)`
  margin-bottom: 0;
  @media (min-width: ${props => props.theme.media.laptop}) {
    margin-bottom: 34px;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  @media (min-width: 515px) {
    padding: 0px;
    flex-direction: row;
  }
`;

const SeeMoreDesktop = styled.a`
  cursor: pointer;
  display: none;
  @media (min-width: ${props => props.theme.media.laptop}) {
    display: block;
  }
`;

const SeeMoreText = styled(T)`
  color: ${props => props.theme.colors.main} !important;
  margin-right: 9px;
`;

const StyledButton = styled(Button)`
  align-self: center;
  margin-bottom: 34px;
  ${props =>
    props.fullWidthButton &&
    `
    padding-left: 0;
    padding-right: 0;
    min-width: 100%;
  `} @media (min-width: 600px) {
    padding-left: 40px;
    padding-right: 40px;
    min-width: auto;
  }
  @media (min-width: ${props => props.theme.media.laptop}) {
    display: none;
  }
`;

const HelpText = styled(T)`
  line-height: 21px !important;
  color: ${props => props.theme.colors.mainText};
  margin-bottom: 24px;
  @media (min-width: 1366px) {
    display: none;
  }
`;

const HelpIcon = styled.div`
  position: relative;
  display: none;
  margin-left: 10px;
  margin-right: auto;
  margin-top: 8px;
  text-align: center;
  @media (min-width: 1366px) {
    display: block;
  }
  &:hover > div {
    display: block;
    opacity: 1;
  }
`;

const ToolTip = styled.div`
  display: none;
  opacity: 0;
  transition: 0.3s;
  box-shadow: 0 2px 7px rgba(67, 67, 67, 0.3);
  background: white;
  border: 1px solid ${props => props.theme.colors.filter};
  top: 50%;
  transform: translateY(-50%);
  left: 40px;
  z-index: 10;
  padding: 15px;
  position: absolute;
  width: 341px;
  color: ${props => props.theme.colors.mainText};
  font-family: dinpro-regular;
  letter-spaceing: -0.01em;
  font-size: 14px;
  line-height: 21px;
  border-radius: 6px;
  &:after {
    width: 0;
    height: 0;
    content: '';
    border-style: solid;
    top: 50%;
    transform: translateY(-50%);
    border-width: 10px 15px 10px 0;
    border-color: transparent white transparent transparent;
    position: absolute;
    left: -14px;
  }
  &:before {
    width: 0;
    height: 0;
    content: '';
    border-style: solid;
    top: 50%;
    transform: translateY(-50%);
    border-width: 10px 15px 10px 0;
    border-color: transparent ${props => props.theme.colors.filter} transparent
      transparent;
    position: absolute;
    left: -16px;
  }
`;

class GroupList extends Component {
  render() {
    const {
      title,
      seeAllText,
      fullWidthButton,
      helpText,
      children,
      hide,
      theme,
      onSeeMore,
    } = this.props;

    if (hide) return null;

    return (
      <Root d="column">
        <Flex full j="space-between">
          {title && <GroupTitle>{title}</GroupTitle>}
          {helpText && (
            <HelpIcon>
              <Info size={12} color={theme.colors.main} />
              <ToolTip>{helpText}</ToolTip>
            </HelpIcon>
          )}
          {seeAllText && (
            <SeeMoreDesktop onClick={onSeeMore}>
              <SeeMoreText bold> {`${seeAllText} `}</SeeMoreText>
              <ArrowRight size={8} color={theme.colors.main} />
            </SeeMoreDesktop>
          )}
        </Flex>
        {helpText && <HelpText>{helpText}</HelpText>}
        <Wrapper>{React.Children.map(children, child => child)}</Wrapper>
        {seeAllText && (
          <StyledButton onClick={onSeeMore} fullWidthButton={fullWidthButton}>
            {seeAllText}
          </StyledButton>
        )}
      </Root>
    );
  }
}

GroupList.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  helpText: PropTypes.string,
  seeAllText: PropTypes.string,
  fullWidthButton: PropTypes.bool,
  hide: PropTypes.bool,
  onSeeMore: PropTypes.func,
  // styled-components theme
  theme: PropTypes.shape({}).isRequired,
};

GroupList.defaultProps = {
  children: null,
  title: undefined,
  helpText: undefined,
  seeAllText: undefined,
  fullWidthButton: false,
  hide: false,
  onSeeMore: undefined,
};

export default withTheme(GroupList);
